import React, { useEffect, useState } from 'react'
import { usePopup } from '../contexts/PopupContext';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { useNavigation } from '../contexts/NavigationContext';

import { jsPDF } from "jspdf";
import "jspdf-autotable";

import styled from 'styled-components';
import { faPlus, faPercent, faHandHoldingDollar, faEye, faTableList, faListCheck, faCircleCheck, faMagnifyingGlass, faFileCirclePlus, faChevronLeft, faPen, faUser, faFileCircleCheck, faCertificate, faBook, faTrashCan, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { Wrapper, Header, NameWrapper, Row, Column, ButtonSection, ScheduleLabel, InputName, NavButton } from './shared_details_form_styles';
import { TableSection, H4, Table, Th, Td, Tr, TableIconButton } from '../table_styles';
import Enrollment from './Enrollment';
import GradeOnAssignment from './GradeOnAssignment';
import GradeOnEnrollment from './GradeOnEnrollment';
import CreateAssignment from './CreateAssignment';
import GetAttendanceCode from './GetAttendanceCode';
import AddPaymentRecord from './AddPaymentRecord';
import { deleteAssignment } from '../actions/assignmentsActions';
import { deleteEnrollment } from '../actions/enrollmentActions';
import { updateSubjectInstance, setSubjectInstances, getAttendanceCode } from '../actions/subjectInstanceActions';
import { setSelectedStudent, setSelectedSubjectInstance, unsetSelectedStudent } from '../actions/selectionActions';
import { deleteStudent, setStudents } from '../actions/studentActions';
import ScheduleManager from '../components/scheduleManager';

import LoadingSpinner from '../components/LoadingSpinner';
// import styled from 'styled-components';

const LabelOfCheckbox = styled(Label)`

    flex-direction: row;
    align-self: flex-end;
    margin-bottom:0;
  
`;


export const Subject = () => {
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null);
  const subjectInstancesArray = useSelector((state) =>
    state.subjectInstances ? state.subjectInstances : null);
  const selectedSubjectInstance = useSelector((state) =>
    state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null);
  const enrollmentsArray = useSelector((state) =>
    state.enrollments ? state.enrollments : null);
  const assignmentsArray = useSelector((state) =>
    state.assignments ? state.assignments : null);
  const gradesArray = useSelector((state) =>
    state.grades ? state.grades : null);

  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState("");
  // const [price, setPrice] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [zoom_link, setZoom_link] = useState("");
  const [schedule, setSchedule] = useState([]);
  const [subjectInstanceOfPage, setSubjectInstanceOfPage] = useState(null);
  const [timeFormAction, setTimeFormAction] = useState(null);
  const [isSpecial, setIsSpecial] = useState(false);

  const { openPopup } = usePopup();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { navigateTo } = useNavigation();

  useEffect(() => {
    if (studentsArray.length === 0 || subjectInstancesArray.length === 0) {
      navigateTo(`subjects`);
    }
    window.scrollTo(0, 0);

  }, []);

  useEffect(() => {
    if (selectedSubjectInstance) {
      setName(selectedSubjectInstance.subject.name);
      // setPrice(selectedSubjectInstance.price);
      setIsSpecial(selectedSubjectInstance.price?true:false)
      setStartDate(selectedSubjectInstance.startDate);
      setEndDate(selectedSubjectInstance.endDate);
      setZoom_link(selectedSubjectInstance.zoom_link);
      setSchedule(transformSchedule(selectedSubjectInstance.schedule));
      setSubjectInstanceOfPage(selectedSubjectInstance)
    }
  }, [])

  const handleEdit = () => {
    setIsEditing(true)
  };
  const handleGetAttendanceCode = () => {
    dispatch(getAttendanceCode(subjectInstanceOfPage));
    openPopup(<GetAttendanceCode />);
  };
  const handlePay = () => { openPopup(<AddPaymentRecord />); };
  const handleSeeStudent = (student) => {
    dispatch(setSelectedStudent(student));
    navigateTo(`/student/${student._id}`);
  };
  const handleEnrollment = () => {
    dispatch(setSelectedSubjectInstance(subjectInstancesArray.find(subj=>subj._id==selectedSubjectInstance._id)));
    openPopup(<Enrollment subjectInstanceId={id} />);
  };
  const handleEnrollmentEdit=(enrollment)=>{
    dispatch(setSelectedStudent(enrollment.student));
    dispatch(setSelectedSubjectInstance(subjectInstancesArray.find(subj=>subj._id==selectedSubjectInstance._id)));
    openPopup(<Enrollment subjectInstanceId={id} edit={true}  enrollmentId={enrollment._id}/>);
  };
  const handleGradeSubject = (student = null) => {
    dispatch(setSelectedSubjectInstance(subjectInstanceOfPage));
    if (!student) {
      openPopup(<GradeOnEnrollment subjectInstanceId={id} />);
    } else {
      dispatch(setSelectedStudent(student));
      openPopup(<GradeOnEnrollment studentId={student._id} subjectInstanceId={id} />);
    }
  };

  const handleGradeAssignment = (student) => {
    dispatch(setSelectedSubjectInstance(subjectInstanceOfPage));
    if (student) {
      dispatch(setSelectedStudent(student));
      openPopup(<GradeOnAssignment subjectInstanceId={id} studentId={student._id} />);
    }
    else {
      dispatch(unsetSelectedStudent());
      openPopup(<GradeOnAssignment subjectInstanceId={id} />);
    }
  };
  const handleGradeAssignmentbyAssignmentid = (assignmentId) => {
    dispatch(setSelectedSubjectInstance(subjectInstanceOfPage));
    openPopup(<GradeOnAssignment subjectInstanceId={id} assignmentId={assignmentId} />);
  };
  const handleAddAssignmentToSubjectInstance = () => {
    dispatch(setSelectedSubjectInstance(subjectInstanceOfPage));
    openPopup(<CreateAssignment subjectInstanceId={id} />);
  };
  const handleEditAssignment = (assignment) => {
    openPopup(<CreateAssignment assignment={assignment} />);
  };
  const handleDeleteAssignment = async (assignmentId) => {
    dispatch(deleteAssignment(assignmentId));
  };
  const handleDeleteEnrollment = async (enrollmentId) => {
    dispatch(deleteEnrollment(enrollmentId));
  };
  // const handleScheduleEdition = async () => {
  //   openPopup(
  //     <ScheduleManager
  //       schedule={schedule}
  //       setSchedule={setSchedule}
  //       timeFormAction={timeFormAction}
  //       setTimeFormAction={setTimeFormAction}
  //     />);
  // };
  const goBack = () => {
    setIsEditing(true);
    navigateTo('subjects');
  };
  const handleSave = () => {
    const formattedSchedule = schedule.map((time) => `${time.day} - ${time.hour}`);
    const updatedSubjectInstance = {
      subjectInstanceId: selectedSubjectInstance._id,
     // price: parseFloat(price),
      price: isSpecial ? 100 : null,
      startDate,
      schedule: formattedSchedule,
      endDate,
      zoom_link,
    };

    dispatch(updateSubjectInstance(updatedSubjectInstance));
    setIsEditing(false)

  };
  const generatePdf = () => {
    const doc = new jsPDF();

       const headerColor = [96, 3, 3]; // RGB color for #600303
       doc.setFont("Helvetica", "bold");
       doc.setFontSize(22);
       doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);

    doc.text(`Students enrroled in  ${subjectInstanceOfPage.subject.name}`, 14, 20);

    const body = subjectInstanceOfPage && enrollmentsArray?.length > 0 && enrollmentsArray.filter(enrollment => enrollment.subjectInstance._id == subjectInstanceOfPage._id).map(enrollment => [
      enrollment.student.name,
      enrollment.schedule,
      enrollment.attendances ? enrollment.attendances.filter(at => at.status === 'Ausente').length : 0,

      assignmentsArray
          ? assignmentsArray
              .filter(ass => ass.subjectInstance?._id === enrollment.subjectInstance._id)
              .map((ass, index) =>
                  gradesArray && gradesArray.length > 0
                      ? (gradesArray.find(gr => gr.assignment?._id === ass?._id && gr.student?._id === enrollment.student?._id)?.grade || "Pendiente")
                      : "Pendiente"
              )
              .filter(Boolean) // Remove empty strings
              .join(", ")
          : "",
      enrollment.status === 'dropped' && !enrollment.grade ? 0 : enrollment.grade
  ]);
    
    doc.autoTable({
      startY: 30,
      head: [['Name', 'Schedule', 'Absenses', 'Assignments Grades', 'Final Grade']],
      body: body,
      headStyles: { fillColor: '#600303' }

    });

    doc.save(`enrolled_students_${subjectInstanceOfPage.subject.name}.pdf`);
  };

  const transformSchedule = (scheduleArray) => {

    return scheduleArray.map((entry) => {
      const [day, hour] = entry.split(' - ').map(part => part.trim());
      return { day, hour };
    });
  };



  return (
    <Wrapper>

      <Header>
        <NameWrapper>
          <InputName
            type="text"
            name="name"
            value={name}
            onChange={(e) => { setName(e.target.value) }}
            disabled={!isEditing}
          />
          {!isEditing && (
         <ScheduleLabel style={{ whiteSpace: 'nowrap' , flexDirection:'row'}}>
         {schedule.length > 0 &&
           schedule.map((item, index) => {
             let displayText;
             if (typeof item === 'string') {
               // Handle the original schedule format
               const [day, hour] = item.split(' - ').map(part => part.trim());
               displayText = `${day}, ${hour}`;
             } else {
               // Handle the transformed schedule format
               displayText = `${item.day}, ${item.hour}`;
             }
     
             return (
               <span key={index} style={{ display: 'inline', marginRight: '5px' }}>
                 {displayText}
                 {index < schedule.length - 1 ? ' - ' : ''}
               </span>
             );
           })}
       </ScheduleLabel>
          )}
          {isEditing && (
            <ScheduleManager
              schedule={schedule}
              setSchedule={setSchedule}
              timeFormAction={timeFormAction}
              setTimeFormAction={setTimeFormAction}
            />
          )}

        </NameWrapper>
        {!isEditing && (
          <ButtonSection>
            {/* {previousLocation && !previousLocation.pathname.includes('student') && ( */}
            <NavButton onClick={goBack}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </NavButton>
            {/* )} */}
            <Button onClick={() => handleEdit()}><FontAwesomeIcon icon={faPen} /></Button>
            <Button onClick={() => handleAddAssignmentToSubjectInstance()}><FontAwesomeIcon icon={faFileCirclePlus} /></Button>
            <Button onClick={() => handleEnrollment()}><FontAwesomeIcon icon={faUser} /></Button>
            <Button onClick={() => handleGradeSubject()}><FontAwesomeIcon icon={faCertificate} /></Button>
            <Button onClick={() => handleGradeAssignment()}><FontAwesomeIcon icon={faListCheck} /></Button>
            <Button onClick={() => handleGetAttendanceCode()}><FontAwesomeIcon icon={faCircleCheck} /></Button>
            <Button onClick={generatePdf}><FontAwesomeIcon icon={faDownload} /></Button>
          </ButtonSection>
        )}
      </Header>
      <Row>
        <Column>
          <Label>
           Start Date:
            <Input
              type="date"
              name="startDate"
              value={startDate ? startDate.split('T')[0] : ""}
              onChange={(e) => { setStartDate(e.target.value) }}
              disabled={!isEditing}
            />
          </Label>

          <Label>
            End Date:
            <Input
              type="date"
              name="endDate"
              value={endDate ? endDate.split('T')[0] : ""}
              onChange={(e) => { setEndDate(e.target.value) }}
              disabled={!isEditing}
            />
          </Label>
        </Column>
        <Column>
          {/* <Label>
            Precio Mensual:
            <Input
              type="text"
              name="price"
              value={price ? price : ""}
              onChange={(e) => { setPrice(e.target.value) }}
              disabled={!isEditing}
            />
          </Label> */}
          <Label>
            Zoom Link:
            <Input
              type="text"
              name="zoom_link"
              value={zoom_link ? zoom_link : ""}
              onChange={(e) => { setZoom_link(e.target.value) }}
              disabled={!isEditing}
            />
          </Label>
          <LabelOfCheckbox>
            Special:
            <Input
              type="checkbox"
              name="isSpecial"
              checked={isSpecial}
              onChange={(e) => setIsSpecial(e.target.checked)}
              disabled={!isEditing}
            />
          </LabelOfCheckbox>
        </Column>
      </Row>

      {isEditing && (<div style={{display:'flex', gap:'10px'}}>
        <Button onClick={handleSave}>Save</Button>
        <Button onClick={()=>{setIsEditing(false);}}>Cancel</Button>
        </div>
      )}
      <TableSection>
        <H4>Students</H4>
        <Table>
          <thead>
            <Tr>
              <Th>Name</Th>
              <Th>Schedule</Th>
              <Th>Absenses</Th>
              <Th>Assignments Grades</Th>
              <Th>Final Grade</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {subjectInstanceOfPage && enrollmentsArray?.length > 0 && enrollmentsArray.filter(enrollment => enrollment.subjectInstance._id == subjectInstanceOfPage._id).map((enrollment, index) => (
              <Tr key={index}>
                <Td>{enrollment.student && enrollment.student.name}</Td>
                <Td>{enrollment.schedule}</Td>
                <Td>{enrollment.attendances ? enrollment.attendances.filter(at => at.status == 'Ausente').length : 0}</Td>
                <Td>
                  {
                    assignmentsArray
                      ? assignmentsArray
                        .filter(ass => ass.subjectInstance?._id === enrollment.subjectInstance._id)
                        .map((ass, index) =>
                          gradesArray && gradesArray.length > 0
                            ? (gradesArray.find(gr => (gr.assignment?._id === ass?._id) && (gr.student?._id == enrollment.student?._id))?.grade || "Pendiente")
                            : "Pendiente"
                        )
                        .filter(Boolean) // Remove empty strings
                        .join(",")
                      : ""
                  }
                </Td>
                <Td>{(enrollment.status=='dropped'&&!enrollment.grade)?0:enrollment.grade}</Td>
                <Td>
                  <TableIconButton onClick={() => handleSeeStudent(enrollment.student)}><FontAwesomeIcon icon={faEye} /></TableIconButton>
                  <TableIconButton onClick={() => handleEnrollmentEdit(enrollment)}><FontAwesomeIcon icon={faPen} /></TableIconButton>
                  <TableIconButton onClick={() => handleDeleteEnrollment(enrollment._id)}><FontAwesomeIcon icon={faTrashCan} /></TableIconButton>
                  <TableIconButton onClick={() => handleGradeSubject(enrollment.student)}><FontAwesomeIcon icon={faCertificate} /></TableIconButton>
                  <TableIconButton onClick={() => handleGradeAssignment(enrollment.student)}><FontAwesomeIcon icon={faListCheck} /></TableIconButton>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableSection>

      <TableSection>
        <H4>Assignments</H4>
        <Table>
          <thead>
            <Tr>
              <Th>Title</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {subjectInstanceOfPage && assignmentsArray?.length > 0 && assignmentsArray.filter(assignment => assignment.subjectInstance?._id == subjectInstanceOfPage?._id).map((assignment, index) => (
              <Tr key={index}>
                <Td>{assignment.name}</Td>
                <Td>
                  <TableIconButton onClick={() => handleEditAssignment(assignment)}><FontAwesomeIcon icon={faPen} /></TableIconButton>
                  <TableIconButton onClick={() => handleDeleteAssignment(assignment._id)}><FontAwesomeIcon icon={faTrashCan} /></TableIconButton>
                  <TableIconButton onClick={() => handleGradeAssignmentbyAssignmentid(assignment._id)}><FontAwesomeIcon icon={faListCheck} /></TableIconButton>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableSection>
    </Wrapper>
  );
};


export default Subject;
